import { get } from 'svelte/store';
import getCreative from './modules/fetch';
import { extractAndSaveVideoList } from './modules/video';
import { getElementClasses, getClosestNumber, roundToDecimalPoint, } from './modules/utils';
import { localCfg as config } from '../../shared/config';
import { playbackSetup } from './modules/playback';
import { globalStore, videoStore, bannerStore, slotStore, resetStores } from './modules/stores';
import './kervFrame.css';
import { PLAYBACK } from '../../shared/const';
const me = document.currentScript;
const elemDataset = me.dataset;
const eventTarget = new EventTarget();
const trackEvents = {};
const frameWrapperID = 'kerv-frame-container';
const videoPlayerUrl = config.apps.player.js;
const videoPlayerCSSUrl = config.apps.player.css;
const overlayUrl = config.apps.overlay.js;
const overlayCssUrl = config.apps.overlay.css;
const socialUrl = config.apps.social.js;
const socialCssUrl = config.apps.social.css;
const connectUrl = config.apps.connect.js;
const connectCssUrl = config.apps.connect.css;
let creativeData;
async function loadCreative(opts) {
    const { slotID } = get(globalStore);
    // prevent multiple loadCreative on same slotID
    if (slotID && slotID === opts.slotID) {
        throw {
            status: 'error',
            message: 'slot already in used',
            opts,
        };
    }
    creativeData = await getPayload(opts);
    const { slot, superFrameContainer } = await setupElements(opts, creativeData);
    if (!slot) {
        throw {
            status: 'error',
            message: 'Slot Could not be setup',
            opts,
        };
    }
    // set if render as banner
    globalStore.update(s => (Object.assign(Object.assign({}, s), { banner: opts.banner, isPreview: opts.isPreview, isScene: opts.isScene, fitContainer: opts.fitContainer, center: opts.center, slotID: opts.slotID })));
    const settings = playbackSetup();
    if (opts.video && 'autoPlay' in opts.video) {
        videoStore.update(s => (Object.assign(Object.assign({}, s), { videoAutoPlay: opts.video.autoPlay })));
    }
    if (opts.banner) { // update size if using banner
        bannerStore.set(opts.bannerSize);
    }
    // determine aspect ratio and set classes
    // if(settings.useOverlay){ // if no overlay do not run
    //   setResponsiveSize(superFrameContainer)
    // }
    // applySlotClasses(settings);
    let useVideoPlayer = false;
    if (creativeData.playback_id === PLAYBACK.TIKTOK && !opts.isPreview) { // disable when not in preview
        useVideoPlayer = false;
    }
    else if (creativeData.playback_id === PLAYBACK.SOCIAL) { // let social handle video
        useVideoPlayer = false;
    }
    else if (creativeData.media_type === 1 && !opts.banner && !opts.isScene) {
        useVideoPlayer = true;
    }
    // apply custom classes to slot
    updateSuperFrameClasses(superFrameContainer);
    superFrameContainer.classList.add(settings.class);
    // TODO: currently overlay banners load their own player, we need to update how we do banners with video
    if (useVideoPlayer) {
        // creatives that use video
        await loadPlayer();
        const controlsOverVideo = settings.videoCtrlOver;
        // initiate video only once
        extractAndSaveVideoList(creativeData);
        setupVideo(controlsOverVideo);
        if (!controlsOverVideo) {
            const { height: h } = get(slotStore);
            slotStore.update(s => (Object.assign(Object.assign({}, s), { height: h + 30 })));
            // store.client.height = store.client.height + 30;
            superFrameContainer.classList.add('kerv-player-controls-out');
            // slot.classList.add('video')
        }
        if (controlsOverVideo) {
            if (creativeData.playback_id === 7) { // this might not be needed since we are not allowing tiktiok to use video player
                superFrameContainer.classList.add('kerv-tiktok');
            }
            else {
                superFrameContainer.classList.add('kerv-ctv');
            }
        }
    }
    if (settings.useOverlay) {
        if (creativeData.playback_id === 4 && creativeData.shopping_config) {
            // const test = await loadConnect();
            await setupConnect(creativeData.id);
        }
        else if (creativeData.playback_id === 7 || creativeData.playback_id === 4) {
            const test = await loadSocial();
            await setupSocial();
        }
        else {
            const test = await loadOverlay();
            await setupOverlay();
        }
    }
    // listen for slot size change
    // compare with loaded play
    const slotObserver = new ResizeObserver(entries => {
        setResponsiveSize(superFrameContainer);
    });
    // Don't use if no overlay or with banners
    if (get(globalStore).overlayLoaded && !get(globalStore).banner) {
        slotObserver.observe(slot);
        globalStore.update(s => (Object.assign(Object.assign({}, s), { slotObserver })));
    }
    const { overlayLoaded, playerLoaded } = get(globalStore);
    return {
        status: 'ok',
        overlay: overlayLoaded,
        player: playerLoaded,
        client: get(slotStore),
        opts,
    };
}
function getDivElem(id) {
    return `<div id="${id}"></div>`;
}
function getIframe(id) {
    return `<iframe id="${id}" style="border: none; width: 100%; height: 100%; overflow: hidden;"></iframe>`;
}
async function setupElements(opts, payload) {
    const slot = getElement(opts.slotID);
    if (!slot)
        return { slot: null };
    let superFrameContainer = document.getElementById(frameWrapperID);
    if (!superFrameContainer) {
        const src = payload !== null && payload !== void 0 ? payload : opts.payload;
        const elem = src.playback_id === 4 && src.shopping_config ? getIframe(frameWrapperID) : getDivElem(frameWrapperID);
        slot.insertAdjacentHTML('beforeend', `${elem}`);
    }
    superFrameContainer = document.getElementById(frameWrapperID);
    // store.current = { ...store.current, ...opts, wrapper: superFrameContainer, slotElement: slot };
    globalStore.update(s => (Object.assign(Object.assign({}, s), { slot, superFrameContainer })));
    return { slot, superFrameContainer };
}
async function getPayload(opts) {
    let payload;
    // save payload
    if (opts.payload && Object.keys(opts.payload).length) {
        payload = opts.payload;
    }
    else {
        const { api } = config;
        payload = await getCreative(opts.creativeID, api);
    }
    globalStore.update(s => (Object.assign(Object.assign({}, s), { payload })));
    return payload;
}
function applySlotClasses(settings) {
    const { center, slot, banner } = get(globalStore);
    // apply parent classes
    slot.classList.add('kerv-frame-creative');
    slot.classList.add(settings.class);
    if (center) {
        slot.classList.add('flex-center');
    }
    if (banner) {
        slot.classList.add('banner');
    }
}
function getResponsiveSize(orientation = 'horizontal', ratio) {
    let width, height;
    const { slot } = get(globalStore);
    const { clientWidth: maxWidth, clientHeight: maxHeight } = slot;
    if (orientation === 'horizontal') {
        width = maxWidth;
        height = Math.ceil(width / ratio);
    }
    else {
        height = maxHeight - 30;
        width = Math.ceil(height * ratio);
    }
    return { width, height };
}
function setResponsiveSize(elm) {
    const { video, overlayLoaded, fitContainer, slot } = get(globalStore);
    const { controlsOver } = get(videoStore);
    const ratio = getCreativeAspectRatio();
    const { clientWidth: maxWidth, clientHeight: maxHeight } = slot;
    const controlsHeight = video ? controlsOver ? 0 : 30 : 0;
    const slotAspectRatio = roundToDecimalPoint((maxWidth / (maxHeight - controlsHeight)), 3);
    let sizes, format;
    // if fit container and we are using overlay
    if (fitContainer && overlayLoaded) {
        // based on container
        if (slotAspectRatio < ratio) {
            format = 'horizontal';
            sizes = getResponsiveSize(format, ratio);
        }
        else {
            format = 'vertical';
            sizes = getResponsiveSize(format, ratio);
        }
    }
    else {
        if (slotAspectRatio <= 1) {
            sizes = getResponsiveSize('vertical', ratio);
        }
        else {
            sizes = getResponsiveSize('horizontal', ratio);
        }
    }
    slotStore.update(s => (Object.assign(Object.assign({}, s), { width: sizes.width, height: sizes.height, format })));
    // elm.style.setProperty('--kerv-crv-width', sizes.width + 'px');
    // elm.style.setProperty('--kerv-crv-height', sizes.height + 'px');
    dispatchUpdate('sizeUpdate', get(slotStore));
}
function getCreativeAspectRatio() {
    const { payload } = get(globalStore);
    const { aspect_ratio: aspectRatio, width, height, } = payload.media_asset.metadata;
    if (aspectRatio) {
        return aspectRatio;
    }
    else {
        return roundToDecimalPoint((width / height), 3);
    }
}
function setupVideo(controlsOver = false) {
    const { videos, videoAutoPlay } = get(videoStore);
    const { isPreview, slot } = get(globalStore);
    const vidArr = Object.keys(videos);
    const quality = isPreview ? '1080' : getClosestNumber(vidArr, slot.clientHeight);
    window.kervPlayer.setUp(`#${frameWrapperID}`, {
        src: videos[quality].url,
        poster: creativeData.media_asset.poster_image_file_attachment ? 'https://rcdn.kervinteractive.com/' + creativeData.media_asset.poster_image_file_attachment.file : '',
        autoplay: videoAutoPlay,
        controlsOver: controlsOver,
        width: creativeData.media_asset.metadata.width,
        height: creativeData.media_asset.metadata.height,
    });
    videoStore.update(s => (Object.assign(Object.assign({}, s), { controlsOver, videoElement: window.kervPlayer.getVideoElement() })));
}
async function setupOverlay() {
    const { playerLoaded, banner, superFrameContainer, isPreview, isScene } = get(globalStore);
    window.kervEmbedApp.addEventListener('overlayMounted', function () {
        if (creativeData.media_type === 1 && playerLoaded && !banner && !isScene) {
            window.kervPlayer.play();
        }
    });
    if (isScene) {
        window.kervEmbedApp.setOptions({
            useVideo: false,
            slot: superFrameContainer,
            videoPlayer: null,
            creativeID: creativeData.id,
            autoPlayVideo: false,
            payload: creativeData,
            banner: false,
            bannerSize: {},
            fixIphone: true,
            isScene: isScene
        });
    }
    else {
        window.kervEmbedApp.setOptions({
            useVideo: banner ? creativeData.media_type === 1 : playerLoaded,
            slot: superFrameContainer,
            videoPlayer: banner ? undefined : get(videoStore).videoElement,
            creativeID: creativeData.id,
            autoPlayVideo: false,
            payload: creativeData,
            banner,
            bannerSize: get(bannerStore),
            fixIphone: isPreview
        });
    }
    await window.kervEmbedApp.loadOverlay();
}
async function setupConnect(id) {
    const { superFrameContainer } = get(globalStore);
    superFrameContainer.src = `https://rcdn.kervinteractive.com/overlay/v3/qa/connect/index.html?creativeid=${id}&kvcb=1`;
}
async function setupSocial() {
    const { banner, superFrameContainer, isScene } = get(globalStore);
    const params = { creativeId: creativeData.id, slot: superFrameContainer, payload: creativeData, banner, bannerSize: get(bannerStore), isScene };
    await window.kervSocial.loadOverlay(params);
}
function updateSuperFrameClasses(slot) {
    let classes = getElementClasses(slot);
    classes = [...classes, 'kerv-slot-container'];
    slot.classList.add(...classes);
}
async function loadPlayer() {
    const { superFrameContainer } = get(globalStore);
    return Promise.all([
        loadScript(videoPlayerUrl, superFrameContainer),
        loadCSS(videoPlayerCSSUrl, superFrameContainer),
    ])
        .then(r => {
        globalStore.update(s => (Object.assign(Object.assign({}, s), { playerLoaded: true })));
        return true;
    })
        .catch(e => {
        console.debug('Could not load Player script', e);
        return false;
    });
}
async function loadOverlay() {
    const { superFrameContainer } = get(globalStore);
    return Promise.all([
        loadScript(overlayUrl, superFrameContainer),
        loadCSS(overlayCssUrl, superFrameContainer),
    ])
        .then(r => {
        globalStore.update(s => (Object.assign(Object.assign({}, s), { overlayLoaded: true })));
        return true;
    })
        .catch(e => {
        console.debug('Could not load Overlay script', e);
        return false;
    });
}
async function loadConnect() {
    const { superFrameContainer } = get(globalStore);
    return Promise.all([
        loadScript(connectUrl, superFrameContainer),
        loadCSS(connectCssUrl, superFrameContainer),
    ])
        .then(r => {
        globalStore.update(s => (Object.assign(Object.assign({}, s), { overlayLoaded: true })));
        return true;
    })
        .catch(e => {
        console.debug('Could not load Overlay script', e);
        return false;
    });
}
async function loadSocial() {
    const { superFrameContainer } = get(globalStore);
    return Promise.all([
        loadScript(socialUrl, superFrameContainer),
        loadCSS(socialCssUrl, superFrameContainer),
    ])
        .then(r => {
        globalStore.update(s => (Object.assign(Object.assign({}, s), { overlayLoaded: true })));
        return true;
    })
        .catch(e => {
        console.debug('Could not load Overlay script', e);
        return false;
    });
}
function getElement(elm) {
    if (typeof elm === 'string') {
        if (elm.startsWith('.') || elm.startsWith('#')) {
            return document.querySelector(elm);
        }
    }
    else if (typeof elm === 'object') {
        if (elm instanceof HTMLElement) {
            return elm;
        }
    }
    return null;
}
function loadScript(src, parent) {
    return new Promise(function (resolve, reject) {
        var s;
        s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        if (parent) {
            parent.appendChild(s);
        }
        else {
            document.head.appendChild(s);
        }
    });
}
function loadCSS(src, parent) {
    return new Promise(function (resolve, reject) {
        var s;
        s = document.createElement('link');
        s.href = src;
        s.rel = 'stylesheet';
        s.type = 'text/css';
        s.onload = resolve;
        s.onerror = reject;
        if (parent) {
            parent.appendChild(s);
        }
        else {
            document.head.appendChild(s);
        }
    });
}
function dispatchUpdate(eventMsg, params = {}) {
    const event = new CustomEvent(eventMsg, { detail: params });
    eventTarget.dispatchEvent(event);
}
function addEventListener(e, callback) {
    trackEvents[e] = callback;
    eventTarget.addEventListener(e, callback, true);
}
function removeEventListener(e, callback) {
    eventTarget.removeEventListener(e, trackEvents[e], true);
}
function dispose() {
    const { playerLoaded, overlayLoaded, banner, slot, slotObserver, payload = { playback_id: 0 } } = get(globalStore);
    const { playback_id } = payload;
    const isSocialApp = playback_id && playback_id === 4 || playback_id === 7;
    if (playerLoaded && !banner) {
        window.kervPlayer.dispose();
    }
    if (overlayLoaded) {
        if (isSocialApp) {
            window.kervSocial.removeOverlay();
        }
        else {
            window.kervEmbedApp.removeOverlay();
        }
    }
    if (slotObserver) {
        slotObserver.disconnect();
    }
    if (slot) {
        slot.innerHTML = '';
    }
    resetStores();
}
// function updateSize() {
//   const superFrameContainer = document.getElementById(frameWrapperID);
//   setResponsiveSize(superFrameContainer)
// }
/**
 * this function runs automatically on load for embed code
 * load only if creative id is passed in dataSet
 */
const embedCode = () => {
    const creativeId = elemDataset.creativeid;
    const origWidth = Number(elemDataset.width);
    const origHeight = Number(elemDataset.height);
    const imgSetting = Boolean(elemDataset.img);
    const htmlFile = !!imgSetting ? 'img' : 'vid';
    const frame_id = 'kerv-frame-' + creativeId;
    const baseSrc = '__src';
    const env = '__env';
    //@ts-ignore <- Using this to prevent TypeScript from calling out the fact that env is a constant and it should not be compared to a string because it will always return the same result.
    const srcURL = env === 'local' ? `http://localhost:8888` : baseSrc;
    //@ts-ignore <- Using this to prevent TypeScript from calling out the fact that env is a constant and it should not be compared to a string because it will always return the same result.
    const localDev = env === 'local' ? `&envURL=${srcURL}` : '';
    const container = document.createElement('div');
    me.parentNode.insertBefore(container, me.nextSibling);
    container.innerHTML = `<iframe id="${frame_id}" class="kerv-frame" src="${srcURL}/${htmlFile}.html?creative_id=${creativeId}&cb=${Date.now()}&env=${env}${localDev}" width="100%" height="100%" frameBorder="0" scrolling="no"></iframe>`;
    const resize = () => {
        const frameElem = document.getElementById(frame_id);
        const currentWidth = frameElem.offsetWidth;
        const ratio = currentWidth / origWidth;
        const newTop = 0;
        let newHeight = origHeight * ratio;
        if (!imgSetting) {
            newHeight += 30;
        }
        frameElem.style.top = newTop + 'px';
        frameElem.style.height = newHeight + 'px';
    };
    document.addEventListener('DOMContentLoaded', () => resize());
    window.addEventListener('resize', () => resize());
};
if ('creativeid' in elemDataset) {
    embedCode();
}
export { loadCreative, addEventListener, removeEventListener, dispose };
